module.exports = __webpack_public_path__ + "static/img/anxun12.7215fb5d.jpg";